import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '@core/services/storage/storage.service';

@Injectable()
export class HttpLostLocalstorageInterceptor implements HttpInterceptor {
  constructor(private storageService: StorageService) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.checkLocalStorageState();

    return next.handle(request);
  }

  private checkLocalStorageState() {
    if (!localStorage.length) {
      Object.keys(this.storageService.localStorageCopy).forEach(key => {
        localStorage.setItem(key, this.storageService.localStorageCopy[key]);
      });
    }
  }
}
